<template>
    <b-card class="mb-2" header-tag="header">
        <template #header>
            <h6 class="mb-0 text-center">
                <i class="fa fa-pie-chart"></i> Información Financiera
            </h6>
        </template>
        <b-row>
            <b-col class="text-center" md="6" cols="12">
                <b-row>
                    <b-col md>
                        <table>
                            <thead>
                                <tr>
                                    <th colspan="2">Ingresos</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Ingreso Básico</td>
                                    <td>
                                        <input
                                            type="text"
                                            class="form-control"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Otros Ingresos</td>
                                    <td>
                                        <input
                                            type="text"
                                            class="form-control"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td><b>Total Ingresos Mensuales</b></td>
                                    <td>
                                        <input
                                            type="text"
                                            class="form-control"
                                            disabled
                                        />
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="2"><b>Total Activos</b></td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <input
                                            type="text"
                                            class="form-control"
                                        />
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </b-col>
                </b-row>
            </b-col>
            <b-col class="text-center" md="6" cols="12">
                <b-row>
                    <b-col md>
                        <table>
                            <thead>
                                <tr>
                                    <th colspan="2">Gastos</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Gastos Financieros</td>
                                    <td>
                                        <input
                                            type="text"
                                            class="form-control"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Gastos Personales</td>
                                    <td>
                                        <input
                                            type="text"
                                            class="form-control"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td><b>Total Gastos Mensuales</b></td>
                                    <td>
                                        <input
                                            type="text"
                                            class="form-control"
                                            disabled
                                        />
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="2"><b>Total Pasivos</b></td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <input
                                            type="text"
                                            class="form-control"
                                        />
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </b-col>
                </b-row>
            </b-col>
            <div class="w-100"></div>
            <b-col md="2">
                <label for="">Declara Renta?</label>
            </b-col>
            <b-col md="1">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" />
                    <label class="form-check-label">
                        Si
                    </label>
                </div>              
            </b-col>
            <b-col md="1">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" />
                    <label class="form-check-label">
                        No
                    </label>
                </div>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
